var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pm.axe !== 1)?_c('section',{staticClass:"Fiche__title text-ttgros",staticStyle:{"font-style":"italic","position":"relative","top":"4px"}},[_c('span',[_vm._v(_vm._s(_vm.secondAxe ? _vm.secondAxe.name : ""))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }